import iltirreno from '../../assets/media_article_logos/il_tirreno.png';
import sole from '../../assets/media_article_logos/il_sole.png';
import gazettadiparma from '../../assets/media_article_logos/gazzetta_di_parma.png';
import larepubblica from '../../assets/media_article_logos/la_repubblica.png';
import millionaire from '../../assets/media_article_logos/millionaire.png';
import radio24 from '../../assets/media_article_logos/radio_24.png';
import forbes from '../../assets/media_article_logos/forbes.png';
import sky from '../../assets/media_article_logos/sky.png';
import './MediaArticles.scss';


const articles = [
    {
        id: 0,
        name: 'Forbes',
        url: 'https://forbes.it/2022/06/07/geoticket-appennino-america-fare-impresa-italia-possibile/',
        logo: forbes
    },
    { id: 1, name: 'Sky', url: 'https://www.youtube.com/watch?v=REjkON9dxcw', logo: sky },
    {
        id: 2,
        name: 'Gazzetta Di Parma',
        url: 'https://www.gazzettadiparma.it/home/2021/12/10/news/l-app-per-andare-a-funghi-o-a-pesca-ora-serve-anche-per-trekking-e-sci-614398/',
        logo: gazettadiparma
    },
    {
        id: 3,
        name: 'Il Tirreno',
        url: 'https://iltirreno.gelocal.it/massa/cronaca/2017/08/12/news/arriva-geoticket-il-tesserino-per-funghi-che-viaggia-on-line-1.15727646',
        logo: iltirreno
    },
    {
        id: 4,
        name: '24 Ore',
        url: 'https://www.radio24.ilsole24ore.com/programmi/paese-migliore/puntata/fuma-spiaggia-170408-ABt5HrUB?fbclid=IwAR0YE1ro1p_DTd_--g65RQTy2w5jvcidyOthX1Ex49asjalnm6fzIP6jLfA',
        logo: sole
    },
    {
        id: 5,
        name: 'La Repubblica',
        url: 'https://parma.repubblica.it/cronaca/2019/02/12/news/geoticket_l_uovo_di_colombo_per_il_marketig_territoriale_dell_appennino-218905737/',
        logo: larepubblica
    },
    {
        id: 6,
        name: 'Millionaire',
        url: 'https://blog.geoticket.it/2019/06/17/grazie-fungaioli/',
        logo: millionaire
    },
    {
        id: 7,
        name: 'Radio24',
        url: 'https://www.radio24.ilsole24ore.com/programmi/paese-migliore/puntata/fuma-spiaggia-170408-ABt5HrUB?fbclid=IwAR0YE1ro1p_DTd_--g65RQTy2w5jvcidyOthX1Ex49asjalnm6fzIP6jLfA',
        logo: radio24
    }
];

const MediaArticles = () => {
    return (
        <ul className="media-articles-container">
            {articles.map((article) => (
                <li key={article.id}>
                    <a href={article.url} target="_blank">
                        <img src={article.logo} alt={article.name} />
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default MediaArticles;
